export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "above_band_alert": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ce produit dépasse la tranche de prix du contrat. L'échange est accepté, mais la valeur assurée sera plafonnée à ", _interpolate(_named("amount")), " (vétusté appliquée sur ce montant)."])}
      },
      "en": {
        "above_band_alert": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["This product exceeds the contract's price band. The exchange is accepted, but the insured value will be capped at ", _interpolate(_named("amount")), " (depreciation applied to this amount)."])}
      }
    }
  })
}
